import * as React from 'react';

import { hideSidePanel, showSidePanel } from '../../redux/ui/actions';

import { Layer } from '@fluentui/react';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

export function PageSidePanel({ children }: React.PropsWithChildren) {
  const dispatch = useDispatch();

  const didMount = useCallback(() => dispatch(showSidePanel()), [dispatch]);
  const willUnmount = useCallback(() => dispatch(hideSidePanel()), [dispatch]);

  return (
    <Layer onLayerDidMount={didMount} onLayerWillUnmount={willUnmount} hostId="sidepanel">
      {children}
    </Layer>
  );
}
